<script setup>
import ButtonBase from "../general/ButtonBase.vue";
defineProps({ blok: Object });
</script>

<template>
  <ButtonBase
    :buttonTitle="blok.buttonText"
    :buttonUrl="blok.file.filename"
    rel="nofollow noreferrer"
    target="_blank"
    class="text-none elevation-0 bg-primary font-weight-bold mt-4"
    :name="blok.buttonText"
  />
</template>
